import * as APIUtils from '@components/Globals/Utils';
import type { ApiConfig } from '../types';
import { apiService } from '@/services/api';
import { socketService } from '@/services/socketService';

class ConversationApi
{
  static SetConversationsAsViewed(
    requestApi: ApiConfig,
    requestParams: { ConversationIds: string },
  )
  {
    return APIUtils.callFetch(
      requestApi,
      'api/alert/SetConversationsAsViewed?conversationIdsString=' + requestParams.ConversationIds,
      'PUT',
    );
  }

  static updateComplete(requestApi: ApiConfig, requestParams: any)
  {
    if (requestParams.DashboardGroupId && requestParams.DashboardGroupId > 0)
    {
      const urlParams =
        '?DashboardGroupId=' +
        requestParams.DashboardGroupId +
        '&ConversationId=' +
        requestParams.ConversationId +
        '&Finished=' +
        requestParams.Finished +
        '&SocketConnectionId=' +
        requestParams.SocketConnectionId;

      return APIUtils.callFetch(
        requestApi,
        'api/conversation/UpdateCompleteDashboardGroupConversation' + urlParams,
        'POST',
      );
    }
    else
    {
      const urlParams =
        '?ConversationId=' +
        requestParams.ConversationId +
        '&Finished=' +
        requestParams.Finished +
        '&SocketConnectionId=' +
        requestParams.SocketConnectionId;

      return APIUtils.callFetch(
        requestApi,
        'api/conversation/UpdateCompleteConversation' + urlParams,
        'PUT',
      );
    }
  }

  static updateTitle(requestApi: ApiConfig, requestParams: any)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/conversation/updateconversationtitle',
      'PUT',
      { ...requestParams, SocketConnectionId: socketService.connectionId },
    );
  }

  static updateRedFlags(requestApi: ApiConfig, requestParams: any)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/conversation/MarkRedFlag',
      'PUT',
      { ...requestParams, SocketConnectionId: socketService.connectionId },
      true,
    );
  }

  static updateImportant(requestApi: ApiConfig, requestParams: any)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/conversation/MarkImportant',
      'PUT',
      { ...requestParams, SocketConnectionId: socketService.connectionId },
      true,
    );
  }

  static updateReplyImportant(requestApi: ApiConfig, requestParams: any)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/reply/MarkReplyImportant',
      'PUT',
      requestParams,
      true,
    );
  }

  static getConversationById(requestApi: ApiConfig, requestParams: any)
  {
    const urlParams =
      '?conversationId=' +
      requestParams.conversationId +
      '&layersToHide=' +
      requestParams.layersToHide +
      '&getAllReplies=' +
      requestParams.getAllReplies +
      '&isConversationDetailsView=' +
      (requestParams.isConversationDetailsView ? requestParams.isConversationDetailsView : false) +
      '&totalReplies=' +
      requestParams.totalReplies;
    return APIUtils.callFetch(
      requestApi,
      'api/Conversation/GetConversationById' + urlParams,
      'POST',
    );
  }

  static getTagList(requestApi: ApiConfig, requestParams: any)
  {
    const urlParams =
      '?configValueId=' +
      requestParams.ConfigValueId +
      '&projectId=' +
      requestParams.ProjectId +
      '&layerIdsSelected=' +
      requestParams.LayerIdsSelected +
      '&groupIdsSelected=' +
      requestParams.GroupIdsSelected +
      '&conversationId=' +
      requestParams.ConversationId;

    return APIUtils.callFetch(requestApi, 'api/Person/getTagList' + urlParams, 'GET');
  }

  static updateBody(requestApi: ApiConfig, requestParams: any)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/conversation/updateconversationbody',
      'PUT',
      { ...requestParams, SocketConnectionId: socketService.connectionId },
    );
  }

  static getMoreReplies(requestApi: ApiConfig, requestParams: any)
  {
    const urlParams =
      '?conversationId=' +
      requestParams.ConversationId +
      '&layersToHide=' +
      requestParams.LayersToHide +
      '&recycleBinDashboard=' +
      requestParams.RecycleBinDashboard +
      '&pageNumber=' +
      requestParams.pageNumber +
      '&pageSize=' +
      requestParams.pageSize +
      '&isConversationDetailsView=' +
      requestParams.isConversationDetailsView +
      '&ConversationPhaseId=' +
      requestParams.ConversationPhaseId +
      '&replyTab=' +
      requestParams.replyTab;

    return APIUtils.callFetch(
      requestApi,
      'api/reply/GetMoreConversationReplies' + urlParams,
      'GET',
    );
  }

  static saveFollower(requestApi: ApiConfig, requestParams: any)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/Notification/SaveConversationsFollower',
      'POST',
      requestParams,
      true,
    );
  }

  static getEmbeddedImages(requestApi: ApiConfig, requestParams: any)
  {
    const urlParams = '?id=' + requestParams.id + '&IsReply=' + requestParams.IsReply;

    return APIUtils.callFetch(requestApi, 'api/Conversation/GetEmbeddedImages' + urlParams, 'GET');
  }

  static createNewPrivateChat(requestApi: ApiConfig, requestParams: any)
  {
    return APIUtils.callFetch(requestApi, 'api/Person/CreateNewPrivateChat', 'POST', requestParams);
  }

  static getContainingDashboards(requestApi: ApiConfig, requestParams: any)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/conversation/GetContainingDashboards?ConversationId=' + requestParams.conversationId,
      'POST',
    );
  }

  static getParentTasks(requestApi: ApiConfig, requestParams: any)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/conversation/GetConversationMetadata?ConversationId=' +
        requestParams.conversationId +
        '&Type=' +
        requestParams.type,
      'POST',
    );
  }

  static getConversationWarnings(requestApi: ApiConfig, requestParams: any)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/conversation/GetConversationWarnings?ConversationId=' + requestParams.conversationId,
      'POST',
    );
  }

  static GetNotificationTypeByPerson(requestApi: ApiConfig, conversationId: number)
  {
    const urlParams = '?conversationId=' + conversationId;

    return APIUtils.callFetch(
      requestApi,
      'api/Conversation/GetNotificationTypeByPerson' + urlParams,
      'GET',
    );
  }

  static newcard(requestApi: ApiConfig, item: any)
  {
    return APIUtils.callFetch(requestApi, 'api/Conversation/newphase', 'POST', item);
  }

  static createNewPhase(requestApi: ApiConfig, item: any)
  {
    return APIUtils.callFetch(requestApi, 'api/Conversation/createphase/', 'POST', {
      ...item,
      SocketConnectionId: socketService.connectionId,
    });
  }

  static changeNameCard(requestApi: ApiConfig, item: any)
  {
    return APIUtils.callFetch(requestApi, 'api/conversation/updateconversationtitle/', 'PUT', {
      ...item,
      SocketConnectionId: socketService.connectionId,
    });
  }

  static deletePhase(requestApi: ApiConfig, item: any)
  {
    return APIUtils.callFetch(requestApi, 'api/conversation/deletephase/', 'POST', {
      ...item,
      SocketConnectionId: socketService.connectionId,
    });
  }

  static getPhases(requestApi: ApiConfig)
  {
    return APIUtils.callFetch(requestApi, 'api/Phase/GetPhases', 'GET');
  }

  static updatePhaseID(requestApi: ApiConfig, item: any)
  {
    return APIUtils.callFetch(requestApi, 'api/Phase/UpdatePhaseID/', 'PUT', item, true);
  }

  static CreateNewOptionPhase(requestApi: ApiConfig, item: any)
  {
    return APIUtils.callFetch(requestApi, 'api/Phase/CreateNewOptionPhase/', 'POST', item, true);
  }

  static GetUserInformationByLayerInternal(requestApi: ApiConfig, personId: number)
  {
    const urlParams = '?personId=' + personId;
    return APIUtils.callFetch(
      requestApi,
      'api/Person/GetUserInformationByLayerInternal' + urlParams,
      'GET',
    );
  }

  static GetFavoritesByReply(requestApi: ApiConfig, replyId: number)
  {
    const urlParams = '?replyId=' + replyId;
    return APIUtils.callFetch(
      requestApi,
      'api/ReplyFavorite/GetReplyFavoriteById' + urlParams,
      'GET',
    );
  }

  static GetFileImages(requestApi: ApiConfig, requestParams: any)
  {
    const urlParams = '?id=' + requestParams.id + '&isReply=' + requestParams.isReply;
    return APIUtils.callFetch(requestApi, 'api/Conversation/GetFileImages' + urlParams, 'GET');
  }

  static GetChatFileImages(requestApi: ApiConfig, requestParams: any)
  {
    const urlParams = '?fileName=' + requestParams.id;
    return APIUtils.callFetch(requestApi, 'api/Chat/GetFileImages' + urlParams, 'GET');
  }

  static insertConversationReaction(requestApi: ApiConfig, requestPayload: any)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/Conversation/InsertConversationReaction',
      'POST',
      { ...requestPayload, SocketConnectionId: socketService.connectionId },
    );
  }

  static updateConversationReaction(requestApi: ApiConfig, requestPayload: any)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/Conversation/UpdateConversationReaction',
      'POST',
      { ...requestPayload, SocketConnectionId: socketService.connectionId },
    );
  }

  static deleteConversationReaction(requestApi: ApiConfig, requestPayload: any)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/Conversation/DeleteConversationReaction',
      'POST',
      { ...requestPayload, SocketConnectionId: socketService.connectionId },
    );
  }

  /**
   * Get custom fields by item ID
   */
  static getCustomFieldsByItemId(
    requestApi: ApiConfig,
    requestParams: {
      coreTaskId: number;
      isDeleted: boolean;
      projectId: number;
    },
  )
  {
    return APIUtils.callFetch(
      requestApi,
      'api/CustomField/GetCustomFieldsByItemId?CoreTaskId=' +
        requestParams.coreTaskId +
        '&IsDeleted=' +
        requestParams.isDeleted +
        '&ProjectId=' +
        requestParams.projectId,
    );
  }

  /**
   * Get conversations data by conversation IDs
   */
  static GetConversationsDataByConversationIds(
    requestApi: ApiConfig,
    requestParams: {
      conversationsIds: string;
    },
  )
  {
    const urlParams = '?conversationsIds=' + requestParams.conversationsIds;
    return APIUtils.callFetch(
      requestApi,
      'api/Conversation/GetConversationsDataByConversationIds' + urlParams,
      'POST',
    );
  }

  // /**
  //  * Get conversations data by conversation IDs
  //  */
  // static GetConversationsByIdsMultiedition(requestApi: ApiConfig, requestParams:{
  //   strConversationsIds: string;
  //   LayersToHide: string;
  //   DashboardId: number;
  // }) {
  //   // const urlParams = '?conversationsIds=' + requestParams.strConversationsIds;
  //   return APIUtils.callFetch(
  //     requestApi,
  //     'api/Conversation/GetConversationsByIdsMultiedition', requestParams,
  //     'POST'
  //   );
  // }

  /**
   * Validate Conversation To Convert
   */
  static async GetConversationsByIdsMultiedition(requestApi: any)
  {
    try
    {
      const response = await apiService.post(
        `Conversation/GetConversationsByIdsMultiedition`,
        requestApi,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error GetConversationsDuplicated:', error);
      throw error;
    }
  }

  static getDashboardsByConfigValueId(requestApi: ApiConfig, configValueId: number)
  {
    return APIUtils.callFetch(
      requestApi,
      `api/dashboard/getbyconfigvalueid?configValueId=${configValueId}`,
      'GET',
    );
  }

  static addDashboardGroupByParameters(
    requestApi: ApiConfig,
    requestParams: {
      dashboardId: number;
      conversationId: number;
      dashboardGroupIdSend: number;
      includeAllConversations: boolean;
      socketid: string;
      isBookmark: boolean;
    },
  )
  {
    const urlParams = `?dashboardId=${requestParams.dashboardId}&dashboardGroupId=null&conversationId=${requestParams.conversationId}&dashboardGroupIdSend=${requestParams.dashboardGroupIdSend}&includeAllConversations=${requestParams.includeAllConversations}&ParentConversationId=0&socketid=${requestParams.socketid ? requestParams.socketid : null}&isBookmark=${requestParams.isBookmark}`;
    return APIUtils.callFetch(
      requestApi,
      `api/dashboard/adddashboardgroupbyparameters${urlParams}`,
      'GET',
    );
  }

  static DeleteDashboardGroupConversation(
    requestApi: ApiConfig,
    requestParams: {
      dashboardId: number;
      conversationId: number;
      dashboardGroupIdSend: number;
      DashboardGroupIdDefault: number;
      pParentId: number;
      pDashboardGroupId: number;
      IsFromBookmark: boolean;
      layersToHide: string;
      socketid: string;
    },
  )
  {
    const urlParams = `?DashboardGroupId=${requestParams.dashboardGroupIdSend}&ConversationId=${requestParams.conversationId}&IsFromBookmark=${requestParams.IsFromBookmark}&DashboardGroupIdDefault=${requestParams.DashboardGroupIdDefault}&pParentId=${requestParams.pParentId}&pDashboardGroupId=${requestParams.pDashboardGroupId}&layersToHide=0&socketConnectionId=${requestParams.layersToHide}`;

    return APIUtils.callFetch(
      requestApi,
      `api/conversation/DeleteDashboardGroupConversation${urlParams}`,
      'POST',
    );
  }

  static notifIsFavoriteExternal(
    requestApi: ApiConfig,
    requestParams: { conversationId: number; socketid?: string },
  )
  {
    const socketId = requestParams.socketid || socketService.connectionId;
    const urlParams = `?conversationId=${requestParams.conversationId}&socketid=${socketId}`;
    return APIUtils.callFetch(
      requestApi,
      `api/conversation/NotifIsFavoriteExternal${urlParams}`,
      'PUT',
      undefined,
      true,
    );
  }
}

export default ConversationApi;
